import React, { useState } from "react"
import { Grid, GridColumn as Column, GridDataStateChangeEvent } from '@progress/kendo-react-grid';
import { process, State } from "@progress/kendo-data-query";
import { Schedule } from "../../../../services/scheduleService";
import { ColumnMenu } from "../../../../utils/ColumnMenu";
import { ScheduleSearchCommand } from "./ScheduleSearchCommand";

type ownProps = {
    data:Schedule[];
}

function ScheduleSearchResults(props:ownProps){
    const [dataState,setDataState] = useState<State>({});
    const createDataState = (dataState: State) => {
            return {
              dataState: dataState === undefined ? {} :dataState,};
          };
    const dataStateChange = (event: GridDataStateChangeEvent) => {
            let updatedState = createDataState(event.dataState);
            setDataState(updatedState.dataState);
          };
    const mapCases = ():Schedule[] => {
        return props.data.map(i => ({...i, serviceDate: new Date(i.serviceDate!)}))
    }


    return <React.Fragment>
        <Grid data={process(mapCases().slice(0),dataState)} {...dataState}
            style={{height:'500px'}} onDataStateChange={dataStateChange}>
                <Column cell={ScheduleSearchCommand} width={'75px'} />
                <Column field='accountNumber' title='Account' columnMenu={ColumnMenu} />
                <Column field="lastName" title='Last Name' columnMenu={ColumnMenu} />
                <Column field="firstName" title='First Name' columnMenu={ColumnMenu} />
                <Column field="serviceDate" title='Service Date' format='{0:MM/dd/yyyy}' columnMenu={ColumnMenu} />        
        </Grid>
    </React.Fragment>
}
export {ScheduleSearchResults}